import React, { useState, useContext, useEffect } from 'react'
import { DeleteOutline } from '@material-ui/icons'
import listContext from '../../../Common/context/context'
import searchContext from '../../../PropertySearch/FiltersComponent/context/context'
import PropTypes from 'prop-types'
import updatePropertyList from '../../Utility/UpdatePropertyList/UpdatePropertyList'
import { getUserSFId, getErrorAlertDuration } from '../../../PropertySearch/Utility/Utility'
import Modal from 'react-modal'
import { pollMessageStatus } from '../../Utility/GetMessageStatus/GetMessageStatus'

const RemovePropertyFromList = props => {

    // const { keycloak } = useKeycloak()
    const [clicked, setClicked] = useState(false)
    const { propertyId } = props
    const { propertyList, fetchListDetails } = useContext(listContext)
    const { fetchSavedLists, setShowAlert, setalertProps, openModalWindow } = useContext(searchContext)
    const [selectedOption, setSelectedOption] = React.useState('')
    const [modalIsOpen, setIsOpen] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null)
    const [deleteClicked, setDeleteClicked] = useState(false)

    useEffect(() => {
        if (clicked) {
            handleRemoveProperty()
        }
    }, [clicked])

    function openModal(inpuVal) {
        setSelectedOption(inpuVal)
        setIsOpen(true)
        handleClose()
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    function closeModal() {
        if (!deleteClicked)
            setIsOpen(false)
    }

    const customStyles = {
        content: {
            top: '30%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -40%)',
            padding: '10px'
        },
        overlay: { zIndex: 1050 }
    }

    const onUpdate = async (message, type) => {

        try {

            if (type === 'success') {
                fetchSavedLists()
                await fetchListDetails()
            }
            setDeleteClicked(false)
            setalertProps({ message, type, duration: type === 'error' ? getErrorAlertDuration() : '' })
            setShowAlert(true)

            openModalWindow(false)

        } catch (error) {
            console.log(' error in on-Update :: ', error)
        }

    }

    const handleRemoveProperty = async () => {
        let fieldsToUpdate = []

        setDeleteClicked(true)

        let compsList = [...propertyList.compsList]

        let updatedCompsList = compsList.filter(x => x.omniViewPropertyId === propertyId)

        fieldsToUpdate.push({ key: 'lastModifiedById', value: getUserSFId() })
        fieldsToUpdate.push({ key: 'omniViewPropertyListId', value: props.omniViewPropertyListId })
        fieldsToUpdate.push({ key: 'polarisPropertySearchCriteriaId', value: props.polarisPropertySearchCriteriaId })

        fieldsToUpdate.push({ key: 'compType', value: propertyList.compType })
        fieldsToUpdate.push({
            key: 'compsList', value: updatedCompsList.map(item => ({
                "omniViewCompsListId": item.omniViewCompsListId,
                "omniViewPropertyId": item.omniViewPropertyId,
                // "isSubjectProperty": item.isSubjectProperty,
                // "rank": item.rank,
                "action": "delete"
            }))
        })

        openModalWindow(true)
        closeModal()
        const updatePropertyListObj = new updatePropertyList(fieldsToUpdate)
        const response = await updatePropertyListObj.update()

        if (response && response.status === 200) {
            pollMessageStatus(response.data.messageId, onUpdate, '', 'Property Removed from list', 'Something went wrong !!')
        } else {
            const errorMessage = response.data && response.data.message ? response.data.message : 'Something went wrong !!'
            setalertProps({ message: errorMessage, type: 'error' })
            setShowAlert(true)
            setDeleteClicked(false)
            // setSaveClicked(false)
            // props.handleClose()
        }

    }

    return (
        <>
            <button data-testid="test-button-remove-property" className={`btn btn-sm ${clicked ? 'c-disabled' : ''}`} onClick={() => {
                openModal(<div data-testid="test-delete-select-property-popup" className='flex flex-col py-4 gap-4 drawer-w'>
                    <div className='flex flex-row border-b-1 border-base pb-2'>
                        <span className='p-3'>
                            <span className='font-semibold text-4'>{`Remove property from the list?`}</span>
                        </span>
                    </div>
                    <div className='py-2 px-4'>
                        <div className='flex justify-end space-x-4 mt-auto'>
                            <div>
                                <button data-testid='test-delete-property-cancel' onClick={closeModal} className='btn btn-sm' type='button'>Close</button>
                            </div>
                            <div>
                                {deleteClicked ?
                                    <button className="btn btn-sm btn-primary c-disabled">
                                        <span className="loader h-5 w-5 mx-2" ></span>
                                        <span className="px-2">Confirm</span>
                                    </button>
                                    :
                                    <button data-testid='test-delete-property-confirm' onClick={() => handleRemoveProperty()()} className={`btn btn-sm btn-primary`}>Confirm</button>
                                }
                            </div>
                        </div>
                    </div>
                </div>)
            }}>
                {clicked ? <span data-testid="test=spinner-remove-property" className="loader h-5 w-5 mx-2" ></span> : <DeleteOutline fontSize="small" />}
            </button>
            <Modal ariaHideApp={false} isOpen={modalIsOpen} onRequestClose={closeModal}
                closeTimeoutMS={500} style={customStyles} >
                <div data-testid="test-delete-select-property-popup" className='flex flex-col py-4 gap-4 drawer-w'>
                    <div className='flex flex-row border-b-1 border-base pb-2'>
                        <span className='p-3'>
                            <span className='text-3'>{"Selected property will be removed from the list ?"}</span>
                        </span>
                    </div>
                    <div className='py-2 px-4'>
                        <div className='flex justify-end space-x-4 mt-auto'>
                            <div>
                                <button data-testid='test-delete-property-cancel' onClick={closeModal} className='btn btn-sm' type='button'>Close</button>
                            </div>
                            <div>
                                {deleteClicked ?
                                    <button data-testid='test-delete-dummy' className="btn btn-sm btn-primary c-disabled">
                                        <span className="loader h-5 w-5 mx-2" ></span>
                                        <span className="px-2">Confirm</span>
                                    </button>
                                    :
                                    <button data-testid='test-delete-property-confirm' onClick={() => handleRemoveProperty()} className={`btn btn-sm btn-primary`}>Confirm</button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

RemovePropertyFromList.propTypes = {
    propertyId: PropTypes.string
}

export default RemovePropertyFromList
